import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { CurrencySymbolsService } from '../../../services/currency-symbols/currency-symbols.service';

export const setupCurrenciesGuard: CanActivateFn = () => {
  const platform = inject(PLATFORM_ID);
  const currenciesSymbolService = inject(CurrencySymbolsService);

  if (isPlatformBrowser(platform)) {
    return true;
  }

  return currenciesSymbolService.fetchCurrencySymbols().pipe(map(() => true));
};
